import KegsList from "./KegsList";

export default {
    list: KegsList
};
